export enum Status2FA {
  NONE = 'none',
  AUTHENTICATED = 'authenticated',
  TWOFACTOR = 'two-factor',
  TWOFACTORREGISTER = 'two-factor-register',
}
